import React, { useState, useEffect, ChangeEvent } from 'react';
import _ from 'lodash';
import WaiverService from './WaiverService';
import { Waiver } from '../../js/headersegment/interfaces';

interface WaiverSelectorProps {
  onChange: (waiver: Waiver) => void;
  initialWaiver?: Waiver;
  className?: string;
  id?: string;
}

const WaiverSelector: React.FC<WaiverSelectorProps> = ({ onChange, initialWaiver }) => {
  const defaultSelection: Waiver = { id: 0, description: '---None Selected---' };
  const [waivers, setWaivers] = useState<Waiver[]>([defaultSelection]);
  const [selectedWaiver, setSelectedWaiver] = useState<Waiver>(defaultSelection);

  useEffect(() => {
    const loadWaivers = async () => {
      try {
        const response = await WaiverService.getWaivers();
        setWaiversData(response.data);
        selectInitialWaiver(response.data);
      } catch (error) {
        console.error('Failed to load waivers:', error);
      }
    };

    const setWaiversData = (waiverData: Waiver[]) => {
      const activeWaivers = _(waiverData)
        .filter(waiver => waiver.status === 'ACTIVE')
        .map(waiver => {
          const name =
            _.size(waiver.name) > 50
              ? `${waiver.name!.substr(0, 47)}...`
              : waiver.name;
          const description = `${waiver.issuingAirlineCode}: ${name}`;
          return { id: waiver.id, description: description };
        })
        .value();
      const defaultText =
        activeWaivers.length > 0
          ? '---None selected---'
          : '---No active waivers---';
      defaultSelection.description = defaultText;
      setWaivers([defaultSelection, ...activeWaivers]);
    };

    const selectInitialWaiver = (waiverData: Waiver[]) => {
      const initial = initialWaiver
        ? _.find(waiverData, (waiver) => waiver.id.toString() === initialWaiver.id.toString())
        : null;
      const waiver = initial ? initial : defaultSelection;
      setSelectedWaiver(waiver);
      // onChange(waiver);
    };

    loadWaivers();
  }, []);

  useEffect(() => {
    if (initialWaiver === null) {
      setSelectedWaiver(defaultSelection);
    }
  }, [initialWaiver]);

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const selected: any = waivers.find(waiver => waiver.id === parseInt(event.target.value));
    setSelectedWaiver(selected);
    onChange(selected);
  };

  return (
    <select value={selectedWaiver.id} onChange={handleChange}>
      {waivers.map(waiver => (
        <option key={waiver.id} value={waiver.id}>
          {waiver.description}
        </option>
      ))}
    </select>
  );
};

export default WaiverSelector;